import React, {Component} from 'react';
import { Modal, Icon, message } from 'antd';
import { SortableContainer, SortableElement, arrayMove } from 'react-sortable-hoc';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';

class SortInnerComponent extends Component {
    state = {
        isShow: true
    }

    onSortEnd = ({oldIndex, newIndex}) => {
        const { item } = this.props;
        const child = item['period_visitList'];
        this.props.sortChildItem(arrayMove(child, oldIndex, newIndex), this.props.curIndex);
    };

    render () {
        const { isShow } = this.state;
        const { item } = this.props;
        const child = item['period_visitList'];
        const hasChild = child ? child.length > 0 : false;
        return (
            <div className='sort-contain' style={{width: '80%', marginLeft: 8}}>
                <div className="sort-header" style={{position: "relative", borderRadius: 5, background: '#3cd0cfc9', fontWeight: 500}}>
                    {item.periodValue ? item.periodValue : item.visitTypeName}
                    {
                       hasChild &&
                       <div
                            className="sort-template-traggle"
                            onClick={(e) => {
                                e.stopPropagation();
                                this.setState({ isShow: !isShow })
                            }}
                        >
                            <Icon type={isShow ? "up" : "down"} style={{fontSize: "12px", position: "relative", top: "1px"}}/>
                        </div>
                    }
                </div>
                {
                    isShow &&
                    <div className="sort-content">
                        <SortableHorList child={child} axis="xy" hideSortableGhost={false} lockToContainerEdges={true} onSortEnd={this.onSortEnd} />
                    </div>
                }
            </div>
        )
    }
}

const SortInnerWrap = SortableElement(({item, curIndex, sortChildItem}) => {
    return (
        <SortInnerComponent sortChildItem={sortChildItem} key={`item-${item.id}`} curIndex={curIndex} item={item} />
    )
});

const SortInnerList = SortableContainer(({items = [], sortChildItem}) => {
    items = items || [];
    return (
        <div>
            {
                items.map((item, index) => (
                    <SortInnerWrap sortChildItem={sortChildItem} key={`item-${index}`} index={index} item={item} curIndex={index}/>
                ))
            }
        </div>
    );
});

const SortableHorItem = SortableElement(({title}) =>
    <div className="sort-item">{title}</div>
);

const SortableHorList = SortableContainer(({child = []}) => {
    return (
        <div className="sort-wrap">
            {
                child.map((value, index) => {
                    if (value.visitTypeName) {
                        return (
                            <SortableHorItem key={value.id} index={index} title={value.visitTypeName} hideSortableGhost={false}/>
                        )
                    }
                })
            }
        </div>
    );
});


class SortComponent extends Component {
    state = {
        isShow: true,
    }

    onSortEnd = ({oldIndex, newIndex}) => {
        const { item } = this.props;
        const child = item['c_list'];
        this.props.getChildItem(arrayMove(child, oldIndex, newIndex), this.props.curIndex);
    };

    sortEnd = ({oldIndex, newIndex}) => {
        const { item } = this.props;
        const child = item['c_list'];
        this.props.getChildItem(arrayMove(child, oldIndex, newIndex), this.props.curIndex);
    };

    sortChildItem = (i, index) => {
        const { item } = this.props;
        const child = item['c_list'];
        child[index]['period_visitList'] = i;
        this.props.getChildItem(arrayMove(child), this.props.curIndex);
    }

    render () {
        const { item } = this.props;
        const { isShow } = this.state;
        const child = item['c_list'];

        let flag = false;
        child.map(item => {
            if (item.periodValue) {
                flag = true;
            }
        });

        const hasChild = child ? child.length > 0 : false;
        return (
            <div className='sort-contain'>
                <div className="sort-header" style={{ position: 'relative' }}>
                    {item.stageValue}
                    {
                       hasChild &&
                       <div
                            className="sort-template-traggle"
                            onClick={(e) => {
                                e.stopPropagation();
                                this.setState({ isShow: !isShow })
                            }}
                        >
                            <Icon type={isShow ? "up" : "down"} style={{fontSize: "12px", position: "relative", top: "1px"}}/>
                        </div>
                    }
                </div>
                <div className="sort-content">
                    {
                        isShow && (
                            !flag
                            ?
                                <SortableHorList child={child} axis="xy" hideSortableGhost={false} lockToContainerEdges={true} onSortEnd={this.onSortEnd} />
                            :
                                <SortInnerList
                                    sortChildItem={this.sortChildItem}
                                    items={child}
                                    axis="y"
                                    lockAxis="y"
                                    hideSortableGhost={false}
                                    helperClass="sortHelper"
                                    onSortEnd={this.sortEnd}
                                />
                        )
                    }
                </div>
            </div>
        )
    }
}

const SortableWrap = SortableElement(({item, curIndex, getChildItem}) => {
    return (
        <SortComponent getChildItem={getChildItem} key={`item-${item.id}`} curIndex={curIndex} item={item} />
    )
});

const SortableList = SortableContainer(({items = [], getChildItem}) => {
    items = items || [];
    return (
        <div>
            {
                items.map((item, index) => (
                    <SortableWrap  getChildItem={getChildItem} key={`item-${index}`} index={index} item={item} curIndex={index}/>
                ))
            }
        </div>
    );
});

class SortList extends Component {
    state = {
        visible: false,
        loading: false,
        items: [],
    }

    loadData = () => {
        const { visitGroupingId } = this.props;
        this.setState({ loading: true });
        $.sendRequest({
            method: 'POST',
            url: API_URL.plan.querySortVisitType,
            data: { visitGroupingId },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    loading: false,
                    items: res.data.sortVisit,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        });
    }

    show = () => {
        this.setState({
            visible: true,
            items: []
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    confirm = () => {
        const { items } = this.state;
        const { visitGroupingId } = this.props;

        const params = {};
        items.forEach((item, index) => {
            for (let key in item) {
                let i = 0, j = 0;
                if (key == "c_list" && !!item[key]) {
                    item[key].map((innerItem, innerIndex) => {
                        for (let innerKey in innerItem) {
                            if (innerKey == "period_visitList" && !!innerItem[innerKey]) {
                                innerItem[innerKey].map((finalItem, finalIndex) => {
                                    for (let finalKey in finalItem) {
                                        if (finalKey != 'item') {
                                            params[`sortVisit[${index}].visits[${innerIndex + i - j}].${finalKey}`] = finalItem[finalKey];
                                        } else {
                                            params[`sortVisit[${index}].visits[${innerIndex + i - j}].item`] = innerIndex + i - j + 1;
                                        }
                                    }
                                    i++;
                                })
                                j++;
                            } else if (innerKey != "visitPeriodId" && innerKey != "periodValue") {
                                if (innerKey == 'item') {
                                    params[`sortVisit[${index}].visits[${innerIndex + i - j}].item`] = innerIndex + i - j + 1;
                                } else {
                                    params[`sortVisit[${index}].visits[${innerIndex + i - j}].${innerKey}`] = innerItem[innerKey];
                                }
                            }
                        }
                    })
                }  else {
                    if (key == "sortNum") {
                        params[`sortVisit[${index}].sortNum`]= index + 1;
                    } else {
                        params[`sortVisit[${index}].${key}`]=item[key];
                    }
                }
            }
        })

        this.setState({ loading: true });
        $.sendRequest({
            method: 'POST',
            url: API_URL.plan.sortVisitType,
            data: {
                ...params,
                visitGroupingId,
            },
            dataType: 'json',
            doneResult: ( res => {
                message.success(res.success);
                this.setState({
                    visible: false,
                    loading: false,
                }, () => {
                    this.props.loadData();
                });
            }),
            errorResult: () => {
                this.setState({ loading: false });
            },
        });
    }

    onSortEnd = ({oldIndex, newIndex}) => {
        const { items } = this.state;
        this.setState({ items: arrayMove(items, oldIndex, newIndex) });
    };

    getChildItem = (item, index) =>{
        const { items } = this.state;
        items[index]['c_list'] = item;
        this.setState({ items });
    }
    
    render() {
        const { visible, loading, items } = this.state;
        return (
            <Modal
                title="排序调整"
                visible={visible}
                onCancel={this.hide}
                onOk={this.confirm}
                className="create-modal sort-modal"
                wrapClassName="vertical-center-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="500px"
            >
                <SortableList
                    getChildItem={this.getChildItem}
                    items={items}
                    axis="y"
                    lockAxis="y"
                    hideSortableGhost={false}
                    helperClass="sortHelper"
                    onSortEnd={this.onSortEnd}
                />
            </Modal>
        );
    }
}

export default SortList;


// WEBPACK FOOTER //
// ./src/components/executeMgr/visitPeriodPlan/components/SortList.js